import React from "react";
import PropTypes from "prop-types";
import { ItemGroup, Loader, Segment } from "semantic-ui-react";
import HomepageRecordsListItem from "./homepage-records-list-item";

const HomepageRecordsList = ({ isLoading, records }) => {
  if (isLoading || !records) {
    return <Loader />;
  }

  if (records.length === 0 || !records) {
    return <>No records found</>;
  }

  return (
    <ItemGroup divided>
      {records.map((record, idx) => (
        <HomepageRecordsListItem record={record} />
      ))}
    </ItemGroup>
  );
};

HomepageRecordsList.propTypes = {
  isLoading: PropTypes.bool,
  records: PropTypes.array,
};

export default HomepageRecordsList;
